/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateInteractionCommand } from '../model/createInteractionCommand';
import { CreateInteractionCommandResult } from '../model/createInteractionCommandResult';
import { EnsureCalendarFeedTokenCommand } from '../model/ensureCalendarFeedTokenCommand';
import { EnsureCalendarFeedTokenCommandResult } from '../model/ensureCalendarFeedTokenCommandResult';
import { GetClientInteractionsQueryResult } from '../model/getClientInteractionsQueryResult';
import { GetCoachInteractionsQueryResult } from '../model/getCoachInteractionsQueryResult';
import { GetInteractionAvailabilityQueryResult } from '../model/getInteractionAvailabilityQueryResult';
import { GetInteractionQueryResult } from '../model/getInteractionQueryResult';
import { GetOverdueInteractionsQueryResult } from '../model/getOverdueInteractionsQueryResult';
import { GetScopedInteractionsQueryResult } from '../model/getScopedInteractionsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { UpdateInteractionCommand } from '../model/updateInteractionCommand';
import { UpdateInteractionCommandResult } from '../model/updateInteractionCommandResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class InteractionsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Whether Contacts is switched on for the caller active organisation
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsAvailabilityGet(observe?: 'body', reportProgress?: boolean): Observable<GetInteractionAvailabilityQueryResult>;
    public interactionsAvailabilityGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetInteractionAvailabilityQueryResult>>;
    public interactionsAvailabilityGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetInteractionAvailabilityQueryResult>>;
    public interactionsAvailabilityGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetInteractionAvailabilityQueryResult>('get',`${this.basePath}/Interactions/availability`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Every interaction for one client, whoever owns it
     * 
     * @param clientUid 
     * @param timeZone 
     * @param isResolved 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsClientGet(clientUid?: string, timeZone?: string, isResolved?: boolean, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<GetClientInteractionsQueryResult>;
    public interactionsClientGet(clientUid?: string, timeZone?: string, isResolved?: boolean, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetClientInteractionsQueryResult>>;
    public interactionsClientGet(clientUid?: string, timeZone?: string, isResolved?: boolean, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetClientInteractionsQueryResult>>;
    public interactionsClientGet(clientUid?: string, timeZone?: string, isResolved?: boolean, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientUid !== undefined && clientUid !== null) {
            queryParameters = queryParameters.set('ClientUid', <any>clientUid);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (isResolved !== undefined && isResolved !== null) {
            queryParameters = queryParameters.set('IsResolved', <any>isResolved);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('Skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('Take', <any>take);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetClientInteractionsQueryResult>('get',`${this.basePath}/Interactions/client`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * One coach diary over a date range, optionally looked through by an org admin
     * 
     * @param fromDate 
     * @param toDate 
     * @param timeZone 
     * @param forUserUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsCoachGet(fromDate?: string, toDate?: string, timeZone?: string, forUserUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCoachInteractionsQueryResult>;
    public interactionsCoachGet(fromDate?: string, toDate?: string, timeZone?: string, forUserUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCoachInteractionsQueryResult>>;
    public interactionsCoachGet(fromDate?: string, toDate?: string, timeZone?: string, forUserUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCoachInteractionsQueryResult>>;
    public interactionsCoachGet(fromDate?: string, toDate?: string, timeZone?: string, forUserUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fromDate !== undefined && fromDate !== null) {
            queryParameters = queryParameters.set('FromDate', <any>fromDate);
        }
        if (toDate !== undefined && toDate !== null) {
            queryParameters = queryParameters.set('ToDate', <any>toDate);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (forUserUid !== undefined && forUserUid !== null) {
            queryParameters = queryParameters.set('ForUserUid', <any>forUserUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetCoachInteractionsQueryResult>('get',`${this.basePath}/Interactions/coach`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the caller calendar subscription token, minting or regenerating it
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsFeedTokenPost(body?: EnsureCalendarFeedTokenCommand, observe?: 'body', reportProgress?: boolean): Observable<EnsureCalendarFeedTokenCommandResult>;
    public interactionsFeedTokenPost(body?: EnsureCalendarFeedTokenCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EnsureCalendarFeedTokenCommandResult>>;
    public interactionsFeedTokenPost(body?: EnsureCalendarFeedTokenCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EnsureCalendarFeedTokenCommandResult>>;
    public interactionsFeedTokenPost(body?: EnsureCalendarFeedTokenCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<EnsureCalendarFeedTokenCommandResult>('post',`${this.basePath}/Interactions/feed-token`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Open follow-ups before today, oldest first
     * 
     * @param timeZone 
     * @param forUserUid 
     * @param isClientScoped 
     * @param organizationUid 
     * @param teamUid 
     * @param groupUid 
     * @param isMyClients 
     * @param ownerUid 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsOverdueGet(timeZone?: string, forUserUid?: string, isClientScoped?: boolean, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<GetOverdueInteractionsQueryResult>;
    public interactionsOverdueGet(timeZone?: string, forUserUid?: string, isClientScoped?: boolean, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetOverdueInteractionsQueryResult>>;
    public interactionsOverdueGet(timeZone?: string, forUserUid?: string, isClientScoped?: boolean, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetOverdueInteractionsQueryResult>>;
    public interactionsOverdueGet(timeZone?: string, forUserUid?: string, isClientScoped?: boolean, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (forUserUid !== undefined && forUserUid !== null) {
            queryParameters = queryParameters.set('ForUserUid', <any>forUserUid);
        }
        if (isClientScoped !== undefined && isClientScoped !== null) {
            queryParameters = queryParameters.set('IsClientScoped', <any>isClientScoped);
        }
        if (organizationUid !== undefined && organizationUid !== null) {
            queryParameters = queryParameters.set('OrganizationUid', <any>organizationUid);
        }
        if (teamUid !== undefined && teamUid !== null) {
            queryParameters = queryParameters.set('TeamUid', <any>teamUid);
        }
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('GroupUid', <any>groupUid);
        }
        if (isMyClients !== undefined && isMyClients !== null) {
            queryParameters = queryParameters.set('IsMyClients', <any>isMyClients);
        }
        if (ownerUid !== undefined && ownerUid !== null) {
            queryParameters = queryParameters.set('OwnerUid', <any>ownerUid);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('Skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('Take', <any>take);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetOverdueInteractionsQueryResult>('get',`${this.basePath}/Interactions/overdue`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a follow-up or an appointment against a client
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsPost(body?: CreateInteractionCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateInteractionCommandResult>;
    public interactionsPost(body?: CreateInteractionCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateInteractionCommandResult>>;
    public interactionsPost(body?: CreateInteractionCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateInteractionCommandResult>>;
    public interactionsPost(body?: CreateInteractionCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateInteractionCommandResult>('post',`${this.basePath}/Interactions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Interactions on the clients in the dashboard scope, whoever owns them
     * 
     * @param fromDate 
     * @param toDate 
     * @param timeZone 
     * @param organizationUid 
     * @param teamUid 
     * @param groupUid 
     * @param isMyClients 
     * @param ownerUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsScopedGet(fromDate?: string, toDate?: string, timeZone?: string, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetScopedInteractionsQueryResult>;
    public interactionsScopedGet(fromDate?: string, toDate?: string, timeZone?: string, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetScopedInteractionsQueryResult>>;
    public interactionsScopedGet(fromDate?: string, toDate?: string, timeZone?: string, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetScopedInteractionsQueryResult>>;
    public interactionsScopedGet(fromDate?: string, toDate?: string, timeZone?: string, organizationUid?: string, teamUid?: string, groupUid?: string, isMyClients?: boolean, ownerUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fromDate !== undefined && fromDate !== null) {
            queryParameters = queryParameters.set('FromDate', <any>fromDate);
        }
        if (toDate !== undefined && toDate !== null) {
            queryParameters = queryParameters.set('ToDate', <any>toDate);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }
        if (organizationUid !== undefined && organizationUid !== null) {
            queryParameters = queryParameters.set('OrganizationUid', <any>organizationUid);
        }
        if (teamUid !== undefined && teamUid !== null) {
            queryParameters = queryParameters.set('TeamUid', <any>teamUid);
        }
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('GroupUid', <any>groupUid);
        }
        if (isMyClients !== undefined && isMyClients !== null) {
            queryParameters = queryParameters.set('IsMyClients', <any>isMyClients);
        }
        if (ownerUid !== undefined && ownerUid !== null) {
            queryParameters = queryParameters.set('OwnerUid', <any>ownerUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetScopedInteractionsQueryResult>('get',`${this.basePath}/Interactions/scoped`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes an interaction, which is also how an appointment is cancelled
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public interactionsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public interactionsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public interactionsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling interactionsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Interactions/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets one interaction
     * 
     * @param uid 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsUidGet(uid: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetInteractionQueryResult>;
    public interactionsUidGet(uid: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetInteractionQueryResult>>;
    public interactionsUidGet(uid: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetInteractionQueryResult>>;
    public interactionsUidGet(uid: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling interactionsUidGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('timeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetInteractionQueryResult>('get',`${this.basePath}/Interactions/${encodeURIComponent(String(uid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sends whatever the appointment recipients are owed. Only its owner may.
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsUidInvitationPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public interactionsUidInvitationPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public interactionsUidInvitationPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public interactionsUidInvitationPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling interactionsUidInvitationPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Interactions/${encodeURIComponent(String(uid))}/invitation`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates an interaction. Only its owner may.
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public interactionsUidPut(uid: string, body?: UpdateInteractionCommand, observe?: 'body', reportProgress?: boolean): Observable<UpdateInteractionCommandResult>;
    public interactionsUidPut(uid: string, body?: UpdateInteractionCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UpdateInteractionCommandResult>>;
    public interactionsUidPut(uid: string, body?: UpdateInteractionCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UpdateInteractionCommandResult>>;
    public interactionsUidPut(uid: string, body?: UpdateInteractionCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling interactionsUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UpdateInteractionCommandResult>('put',`${this.basePath}/Interactions/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
